import { render, staticRenderFns } from "./instantPage.vue?vue&type=template&id=cb08cf56"
import script from "./instantPage.vue?vue&type=script&lang=js"
export * from "./instantPage.vue?vue&type=script&lang=js"
import style0 from "./instantPage.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports